
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CrudService, CustomHttp, ConfigServerService } from '../../../core';
import { Cidade } from '../cidade';
import { CidadeSearchAsync } from './cidade-search-async';
import { Filter } from '../../../models';

@Injectable({
    providedIn: 'root'
})
export class CidadeCrudHttpService {
    resource = 'cidade';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todas as cidades cadastradas */
    search(): Observable<Cidade[]> {
        return this.crudService.search<Cidade>(this.resource);
    }

    searchWithFilter(filter: Filter, drawDatatable: number, offset: number, limit: number, orderBy: number, orderByDir: string): Observable<CidadeSearchAsync> {
        // Params
        let params = new HttpParams()
                        .append('drawDatatable', drawDatatable ? drawDatatable.toString() : null)
                        .append('offset', offset ? offset.toString() : null)
                        .append('limit', limit ? limit.toString() : null)
                        .append('orderBy', orderBy ? orderBy.toString() : null)
                        .append('orderByDir', orderByDir ? orderByDir : '');
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<CidadeSearchAsync>(this.pathApi, {params});
    }

    /** Procura uma única cidade através do seu ID */
    find(id: number): Observable<Cidade> {
        return this.crudService.find<Cidade>(this.resource, id);
    }

    /** Carrega uma única cidade através do seu ID */
    load(id: number): Observable<Cidade> {
        return this.crudService.load<Cidade>(this.resource, id);
    }

    insert(entity: Cidade): Observable<Cidade> {
        return this.crudService.insert<Cidade>(this.resource, entity);
    }

    /** Altera uma cidade existente */
    update(entity: Cidade): Observable<Cidade> {
        return this.crudService.update<Cidade>(this.resource, entity);
    }

    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
